import { LitElement, css, html, type TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { when } from 'lit/directives/when.js';
import { followers, fork, star, watchers } from '../../../svg';
import { baseStyles, dlStyles } from '../../../styles';
import type { RepositoryStatistics } from '../../../entities';

@customElement('umb-market-package-sidebar-repo-statistics')
export class UmbMarketPackageSidebarRepoStatistics extends LitElement {
  @property({ type: Object })
  model?: RepositoryStatistics;

  repoStatBlock = (value?: number, icon?: TemplateResult, label?: string) => {
    if (value === 0) return null;

    return html`
      <umb-market-tooltip .text=${label} x="right">
        <dt>${icon}</dt>
        <dd>${value}</dd></umb-market-tooltip
      >
    `;
  };

  render() {
    if (!this.model) return null;

    return html`<div>
      <span>GitHub statistics</span>
      <dl>
        ${this.repoStatBlock(
          this.model.numberOfFollowers,
          followers,
          'Number of GitHub followers of the package owner'
        )}
        ${this.repoStatBlock(
          this.model.numberOfForks,
          fork,
          'Number of forks of the GitHub repository'
        )}
        ${this.repoStatBlock(
          this.model.numberOfStars,
          star,
          'Number of stars on the GitHub repository'
        )}
        ${this.repoStatBlock(
          this.model.numberOfWatchers,
          watchers,
          'Number of watchers on the GitHub repository'
        )}
      </dl>
      ${when(
        this.model.availableForSponsorship && this.model.sponsorshipUrl,
        () => html` <p>
          Using this package in your project? Show your support by
          <a href="${ifDefined(this.model!.sponsorshipUrl)}" target="_blank"
            >becoming a sponsor</a
          >.
        </p>`
      )}
      <p>
        Github statistics are displayed for publically available, open-sourced
        packages.
      </p>
    </div>`;
  }

  static styles = [
    baseStyles,
    dlStyles,
    css`
      :host {
        display: block;
      }

      p,
      p a {
        font-size: 14px;
        color: #6b6b6b;
      }

      p {
        margin: 1em 0 0;
      }

      p + p {
        margin-top: 0.1em;
      }

      p:last-child {
        margin-bottom: -8px;
      }

      svg {
        stroke-width: 1;
        transition: stroke-width ease .2s;
      }

      umb-market-tooltip {
        flex: 1 0 auto;
        max-width: 150px;
        display: flex;
        position: relative;
        gap: var(--s-spacer);
      }

      umb-market-tooltip:hover svg {
        --fill: var(--uui-color-default);
        stroke-width:2;
      }

      span {
        display: block;
        font-size: 14px;
        color: #6b6b6b;
        margin-bottom: var(--s-spacer);
      }

      dt,
      dd {
        line-height: 1;
      }
    `,
  ];
}
